<div class="content-wrapper">
  <div class="card case-view-card">
    <div class="card-header bg-primary">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <button class="sidebar-toggle btn btn-sm mr-3" (click)="toggleSidebar()" [title]="sidebarExpanded ? 'Collapse Filters' : 'Expand Filters'">
            <i class="icon-menu" *ngIf="!sidebarExpanded"></i>
            <i class="icon-close" *ngIf="sidebarExpanded"></i>
          </button>
          <h4 class="title mb-0">3BC CHAMBERS DIARY</h4>
        </div>
        <div class="d-flex align-items-center">
          <span class="date-label mr-3">Go To Date :</span>
          <input type="date" name="calenderDate" id="calenderDate" class="form-control form-control-sm date-picker" placeholder="Select Goto Date" (change)="setCalenderDate($event)">
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="diary-layout">
        <!-- Expandable Sidebar -->
        <div class="filters-sidebar" [class.expanded]="sidebarExpanded">
          <div class="sidebar-content">
            <!-- Clear Filters -->
            <div class="sidebar-section" *ngIf="userType && userType.userTypeId == 1">
              <button class="btn btn-primary btn-block btn-clear-filters" (click)="clearFilters()">
                <i class="icon-refresh mr-2"></i>Clear Filters
              </button>
            </div>

            <!-- Barrister Selection -->
            <div class="sidebar-section" *ngIf="userType && userType.userTypeId == 1">
              <div class="section-header">
                <h6 class="section-title">
                  <i class="icon-people mr-2"></i>Select Barristers
                </h6>
              </div>
              <div class="barrister-selection">
                <div class="barrister-item" *ngFor="let barrister of barristers"
                     [style.background-color]="barrister.colorCode"
                     (click)="updateBarristerId(barrister.id)"
                     [class.selected]="diaryFilter.selectedId.includes(barrister.id)"
                     [title]="diaryFilter.selectedId.includes(barrister.id) ? 'Click to deselect' : 'Click to select'">
                  <div class="barrister-name">{{barrister.fullname}}</div>
                  <div class="barrister-indicators">
                    <i class="icon-check selected-indicator" *ngIf="diaryFilter.selectedId.includes(barrister.id)"></i>
                    <i class="icon-plus unselected-indicator" *ngIf="!diaryFilter.selectedId.includes(barrister.id)"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filters Section -->
            <div class="sidebar-section">
              <div class="section-header">
                <h6 class="section-title">
                  <i class="icon-settings mr-2"></i>Filter Options
                </h6>
              </div>
              <div class="filters-content">
                <div class="form-group">
                  <label for="entryType">Entry Type</label>
                  <select name="entryType" id="entryType" class="form-control form-control-sm" [(ngModel)]="diaryFilter.entryType" (change)="loadEvents()">
                    <option value="all">All Types</option>
                    <option value="0">New Cases</option>
                    <option value="1">Duplicate Cases</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="caseTypeId">Case Type</label>
                  <select name="caseTypeId" id="caseTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.caseTypeId" (change)="loadEvents()">
                    <option value="all">All Types</option>
                    <option *ngFor="let casetype of caseTypes" value="{{casetype.id}}">{{casetype.name}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="clientTypeId">Client Type</label>
                  <select name="clientTypeId" id="clientTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.clientTypeId" (change)="loadEvents()">
                    <option value="all">All Type</option>
                    <option value="Solicitor">Solicitor</option>
                    <option value="1">Direct Public Access</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="courtId">Court</label>
                  <select name="courtId" id="courtId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.courtId" (change)="loadEvents()">
                    <option value="all">All Courts</option>
                    <option *ngFor="let court of courts" value="{{court.id}}">{{court.courtName}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="fundingTypeId">Funding Type</label>
                  <select name="fundingTypeId" id="fundingTypeId" class="form-control form-control-sm" [(ngModel)]="diaryFilter.fundingTypeId" (change)="loadEvents()">
                    <option value="all">All Types</option>
                    <option *ngFor="let fundingType of fundingTypes" value="{{fundingType.id}}">{{fundingType.name}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="courtBundleReceived">Court Bundle Received</label>
                  <select name="courtBundleReceived" id="courtBundleReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.courtBundleReceived" (change)="loadEvents()">
                    <option value="all">All</option>
                    <option value="Yes- By Eamil">Yes - By Email</option>
                    <option value="Yes - By Post">Yes - By Post</option>
                    <option value="Yes - By Courier">Yes - By Courier</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="attendanceNoteReceived">Attendance Note Received</label>
                  <select name="attendanceNoteReceived" id="attendanceNoteReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.attendanceNoteReceived" (change)="loadEvents()">
                    <option value="all">All</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Not Required">Not Required</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="paymentReceived">Payment Received</label>
                  <select name="paymentReceived" id="paymentReceived" class="form-control form-control-sm" [(ngModel)]="diaryFilter.paymentReceived" (change)="loadEvents()">
                    <option value="all">All</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Deferred">Deferred</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Calendar Area -->
        <div class="calendar-area" [class.sidebar-collapsed]="!sidebarExpanded">
          <div class="calendar-container">
            <full-calendar [options]="calendarOptions" #calendar></full-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
